import * as z from "zod";

/**
 * Removes an address from the SES account-level suppression list so SES
 * sends to it again. `removed` is false when it wasn't listed.
 */
export const removeEmailSuppression = {
  name: "removeEmailSuppression" as const,
  input: z.object({ email: z.string().trim().email() }),
  output: z.object({ removed: z.boolean() }),
};
